export const NAME = "notifications"

export const TYPES = {
  CHAT_MESSAGE_FOR_SELLER: "chatMessageForSeller",
  CHAT_MESSAGE_FOR_BUYER: "chatMessageForBuyer",
  NEW_OFFER_REQUEST: "newOfferRequest",
  NEW_OFFER: "newOffer",
  OFFER_ACCEPTED: "offerAccepted",
}
